module.exports = __webpack_public_path__ + "img/thermocouple-middle-K.365f0b3a.png";